import { writable, get } from "svelte/store";
import { Storage } from '@capacitor/storage';

function createCachedStore(key, defaultValue = "")
{
    const cachedStore = writable(defaultValue);           //declare store
    cachedStore.readFromCache = async () => { 
        const { value } = await Storage.get({ key: key});
        console.log("readFromCache: " + value);
        if (value)
            cachedStore.set(value);
    }
    cachedStore.delete = () => { 
        cachedStore.set(defaultValue);
        Storage.remove({key: key});
    };
    cachedStore.subscribe(value => {   //subscribe to itself, such that every time it changes, we'll write the new value in local cache
        if (value)
            Storage.set({key: key, value: value});
    });

    return cachedStore;
}

export const accessToken = createCachedStore("accessToken");